import React, { Component } from "react";
import UnitVerificationDoc from "./unitVerificationDoc";
import { ArrowRightOutlined } from "@ant-design/icons";

class BankAccountVerificationDoc extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <>
                {(this.props.bankAccountSource === 'UN' && this.state.accountStatus !== "Closed") &&
                    <UnitVerificationDoc
                        bankAccountId={this.props.bankAccountId}
                        bankAccountInfo={this.props.bankAccountInfo}
                        bankAccountSource={this.props.bankAccountSource}
                    />
                }
            </>
        );
    }
}

export default BankAccountVerificationDoc;
